import {NormalComponents, ReactMarkdownProps, ReactNode, SpecialComponents} from "react-markdown/src/ast-to-react";
import * as React from "react";
import ReactMarkdown from "react-markdown";
import {documentToReactComponents} from "@contentful/rich-text-react-renderer";
import {OptionalLink} from "./landingpage/pagesection/HeroBannerTwoColumnsComponent";
import {RichTextContent} from "contentful";

export const DefaultMarkdownRenderComponents : Partial<Omit<NormalComponents, keyof SpecialComponents> & SpecialComponents> = {
    a : (props: React.ClassAttributes<HTMLAnchorElement> & React.AnchorHTMLAttributes<HTMLAnchorElement> & ReactMarkdownProps ) : ReactNode  => {
        return <OptionalLink to={props.href} >{props.children}</OptionalLink>
    },
    p : (props: React.ClassAttributes<HTMLParagraphElement> & React.HTMLAttributes<HTMLParagraphElement> & ReactMarkdownProps ) : ReactNode  => {
        return <span>{props.children}</span>
    },
    img: (props: React.ClassAttributes<HTMLImageElement> & React.ImgHTMLAttributes<HTMLImageElement> & ReactMarkdownProps): ReactNode => {
        const { alt, src } = props;

        const dimensions = /=(\d+)x(\d+)/;
        const size = src ? src.match(dimensions) : null;
        const parsedSrc = src ? src.replace(dimensions, "").trim() : "";
        const imgAlt = alt;
        
        const width = size && !isNaN(Number(size[1])) ? size[1] : undefined;
        const height = size && !isNaN(Number(size[2])) ? size[2] : undefined;
        const sanitizedAlt = imgAlt || "Image";

        return <img alt={sanitizedAlt} width={width} height={height} src={parsedSrc} />;
   },
}

/**
 * Render content from contentful Rich text or strapi Markdown
 * @param rich
 * @param options
 */
export const renderContentAsComponent = (rich : RichTextContent | string, options : any) => {

    if(typeof rich === "string") {
        return <ReactMarkdown components={DefaultMarkdownRenderComponents}>{rich}</ReactMarkdown>
    }
    return documentToReactComponents(rich, options);
}